function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import './PageSubtitle.css';
import { FormattedMessage } from 'react-intl';
import whitelistProps from '../../utils/whitelistProps';
var whitelist = whitelistProps();
export default function PageSubtitle(_ref) {
  var i18n = _ref.i18n,
    i18nKey = _ref.i18nKey,
    attrs = _objectWithoutProperties(_ref, ["i18n", "i18nKey"]);
  return /*#__PURE__*/React.createElement("span", Object.assign({
    className: "_page-heading__subtitle"
  }, whitelist(attrs)), /*#__PURE__*/React.createElement(FormattedMessage, Object.assign({
    id: i18nKey
  }, i18n)));
}